import { money, pct } from "@/lib/fmt";

const Row = ({ label, value, strong, testId, cls = "" }) => (
  <div className={`flex items-center justify-between py-2 ${strong ? "border-t border-slate-200 pt-3" : ""}`}>
    <span className={`text-sm ${strong ? "font-semibold text-slate-800" : "text-slate-500"}`}>{label}</span>
    <span data-testid={testId} className={`font-num whitespace-nowrap pl-3 ${strong ? "text-base font-bold" : "text-sm"} ${cls}`}>{value}</span>
  </div>
);

export const SummaryPanel = ({ calc, currency, entertain, commission, title = "Ringkasan Kalkulasi" }) => {
  const m = calc.final_margin;
  const mColor = m < 0 ? "text-rose-600" : m < 10 ? "text-amber-600" : "text-emerald-600";
  return (
    <div className="card-premium p-6" data-testid="summary-panel">
      <h3 className="font-heading text-lg font-semibold mb-3">{title}</h3>
      <Row label="Harga Beli Barang / Jasa" value={money(calc.item_cost, currency)} testId="sum-item-cost" />
      {calc.freight_total > 0 && <Row label="Freight (import)" value={money(calc.freight_total, currency)} testId="sum-freight" />}
      {calc.maintenance_total > 0 && <Row label="Maintenance (import)" value={money(calc.maintenance_total, currency)} testId="sum-maintenance" />}
      {calc.otex_pct > 0 && <Row label={`OTEX (Other Expense) ${calc.otex_pct}%`} value={money(calc.otex_amount, currency)} testId="sum-otex" />}
      {calc.risk_pct > 0 && <Row label={`Risk ${calc.risk_pct}%`} value={money(calc.risk_amount, currency)} testId="sum-risk" />}
      {calc.fin_pct > 0 && <Row label={`Financial Cost ${calc.fin_pct}%`} value={money(calc.fin_amount, currency)} testId="sum-fin" />}
      <Row label="Entertain" value={money(entertain, currency)} testId="sum-entertain" />
      <Row label="Komisi / Fee" value={money(commission, currency)} testId="sum-commission" />
      <Row label="TOTAL COST" value={money(calc.total_cost, currency)} strong testId="sum-total-cost" />
      <Row label="TOTAL PENAWARAN" value={money(calc.offer_total, currency)} strong testId="sum-offer-total" cls="text-blue-900" />
      {calc.ppn_enabled && (
        <>
          <Row label={`PPN ${Number(calc.ppn_percent ?? 11)}%`} value={money(calc.ppn_amount, currency)} testId="sum-ppn" />
          <Row label="GRAND TOTAL (incl. PPN)" value={money(calc.grand_total, currency)} strong testId="sum-grand-total" cls="text-blue-900" />
        </>
      )}
      <Row label="Gross Profit" value={money(calc.profit, currency)} testId="sum-profit" cls={calc.profit < 0 ? "text-rose-600" : "text-emerald-700"} />
      <div className="mt-4 rounded-xl bg-gradient-to-br from-[#1E3A8A] to-[#0F172A] p-4 text-white">
        <p className="text-xs uppercase tracking-widest text-blue-200">Margin Akhir (dari harga jual)</p>
        <p data-testid="sum-final-margin" className={`font-num text-3xl font-bold mt-1 ${m < 0 ? "text-rose-300" : "text-white"}`}>{pct(m)}</p>
        <p className="text-xs text-blue-200 mt-1">Markup terhadap cost: <span className="font-num">{pct(calc.markup)}</span></p>
        {calc.ppn_enabled && <p className="text-[11px] text-blue-200 mt-1">Margin dihitung dari harga sebelum PPN</p>}
      </div>
      <p className={`mt-2 text-xs ${mColor}`}>{m < 0 ? "Peringatan: penawaran di bawah cost!" : m < 10 ? "Margin tipis, pertimbangkan kembali." : "Margin sehat."}</p>
    </div>
  );
};
